import React from 'react';
import styled from 'styled-components';
import MyInfoBanner from '../../assets/image/video_banner.png';

const BannerContainer = styled.div`
  width: 100%;
  margin: 0;
  text-align: center;
`;

const BannerLink = styled.a`
  display: block;
`;

const BannerImage = styled.img`
  width: 100%;
  height: auto;
  border: none;
`;

const VideoBanner = () => {
  return (
    <BannerContainer>
      <BannerLink target="_blank">
        <BannerImage src={MyInfoBanner} alt="Curriculum Download Process Banner" />
      </BannerLink>
    </BannerContainer>
  );
};

export default VideoBanner;
